import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UserLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [deviceToken, setDeviceToken] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await axios.post(`${API_URL}/api/user/login`, { email, password, deviceToken });
            localStorage.setItem('userToken', res.data.token);
            console.log(res);
            navigate('/userSearch');
        } catch (err) {
            console.error(err.response.data.msg);
        }
    };

    const handleSignupClick = () => {
        navigate('/usersignup');
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="main-container">
            {/* Header */}
            <header className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="header-logo">Lememeprix</div>
                    </div>
                </div>
            </header>

            {/* Login Section */}
            <main className="main-content">
                <div className="login-container">
                    {/* Left Hero Section */}
                    <div className="login-hero">
                        <img
                            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/7183815703-8d5ddd939bfaff58d6b9.png"
                            alt="modern french bakery interior"
                        />
                        <div className="login-overlay">
                            <div className="hero-content">
                                <h1 className="hero-title">Bienvenue</h1>
                                <p className="hero-subtitle">Connectez-vous pour explorer les meilleures spécialités françaises</p>
                            </div>
                        </div>
                    </div>

                    {/* Right Login Form */}
                    <div className="login-form-container">
                        <div className="login-form-wrapper">
                            <div className="login-header">
                                <h2 className="login-title">Se Connecter</h2>
                                <p className="login-subtitle">Accédez à votre compte pour commencer à commander</p>
                            </div>

                            <form className="login-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="email">Adresse Email</label>
                                    <div className="input-wrapper">
                                        <i className="fa-regular fa-envelope"></i>
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder="Entrez votre email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            autoComplete="email"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password">Mot de passe</label>
                                    <div className="input-wrapper">
                                        <i className="fa-solid fa-lock"></i>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            placeholder="Entrez votre mot de passe"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <button type="button" className="password-toggle" onClick={togglePasswordVisibility}>
                                            <i className={showPassword ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="login-options">
                                    <label className="remember-me">
                                        <input type="checkbox" className="remember-me-checkbox" />
                                        <span className="remember-me-text">Se souvenir de moi</span>
                                    </label>
                                    <span className="forgot-password">Mot de passe oublié?</span>
                                </div>

                                <button type="submit" className="login-button">
                                    Se Connecter
                                </button>

                                <div className="social-login">
                                    <div className="social-separator">
                                        <span>Ou continuer avec</span>
                                    </div>
                                </div>

                                <div className="social-buttons">
                                    <button type="button" className="social-button">
                                        <i className="fa-brands fa-google"></i>
                                        Google
                                    </button>
                                    <button type="button" className="social-button">
                                        <i className="fa-brands fa-facebook"></i>
                                        Facebook
                                    </button>
                                </div>

                                <p className="signup-prompt">
                                    Vous n'avez pas de compte?
                                    <span className="signup-link" onClick={handleSignupClick}>S'inscrire</span>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
            <style jsx>{`
                /* Main Container */
                .main-container {
                    min-height: 100vh;
                    background-color: #fff;
                }

                /* Header */
                .header {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    background-color: #fff;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    z-index: 50;
                }

                .header .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 1rem;
                }

                .header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1rem;
                }

                .header-logo {
                    font-size: 1.5rem;
                    font-weight: bold;
                }

                /* Main Content */
                .main-content {
                    padding-top: 5rem;
                }

                /* Login Container */
                .login-container {
                    min-height: calc(100vh - 80px);
                    display: flex;
                }

                @media (max-width: 1023px) {
                    .login-container {
                        flex-direction: column;
                        align-items: center;
                    }
                }

                /* Login Hero Section */
                .login-hero {
                    display: none;
                    width: 50%;
                    position: relative;
                }

                @media (min-width: 1024px) {
                    .login-hero {
                        display: block;
                    }
                }

                .login-hero img {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .login-overlay {
                    position: absolute;
                    inset: 0;
                    background-color: rgba(0, 0, 0, 0.4);
                }

                .hero-content {
                    padding: 3rem;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .hero-title {
                    font-size: 3.75rem;
                    font-weight: bold;
                    color: #fff;
                    margin-bottom: 1.5rem;
                }

                .hero-subtitle {
                    font-size: 1.25rem;
                    color: #fff;
                    opacity: 0.9;
                }

                /* Login Form Container */
                .login-form-container {
                    width: 100%;
                    max-width: 480px;
                    padding: 2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .login-form-wrapper {
                    width: 100%;
                }

                /* Login Header */
                .login-header {
                    text-align: center;
                    margin-bottom: 3rem;
                }

                .login-title {
                    font-size: 2.25rem;
                    font-weight: bold;
                    margin-bottom: 1rem;
                }

                .login-subtitle {
                    color: #6b7280;
                }

                /* Login Form */
                .login-form {
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .form-group label {
                    font-size: 0.875rem;
                    font-weight: 500;
                }

                .input-wrapper {
                    position: relative;
                }

                .input-wrapper i {
                    position: absolute;
                    left: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #9ca3af;
                }

                .login-form input {
                    width: 100%;
                    padding: 0.75rem 1rem;
                    padding-left: 3rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    outline: none;
                    transition: border-color 0.2s ease;
                }

                .login-form input:focus {
                    border-color: #ef4444;
                    box-shadow: 0 0 0 1px #ef4444;
                }

                .password-toggle {
                    position: absolute;
                    right: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #9ca3af;
                }

                /* Login Options */
                .login-options {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .remember-me {
                    display: flex;
                    align-items: center;
                }

                .remember-me-checkbox {
                    width: 1rem;
                    height: 1rem;
                    margin-right: 0.5rem;
                    border: 1px solid #d1d5db;
                    border-radius: 0.25rem;
                }

                .remember-me-text {
                    font-size: 0.875rem;
                    color: #6b7280;
                }

                .forgot-password {
                    font-size: 0.875rem;
                    color: #ef4444;
                    cursor: pointer;
                    transition: color 0.2s ease;
                }

                .forgot-password:hover {
                    color: #dc2626;
                }

                /* Login Button */
                .login-button {
                    width: 100%;
                    padding: 0.75rem 1.5rem;
                    border-radius: 0.5rem;
                    background-color: #ef4444;
                    color: #fff;
                    font-weight: 500;
                    cursor: pointer;
                    transition: background-color 0.2s ease;
                    border: none;
                }

                .login-button:hover {
                    background-color: #dc2626;
                }

                /* Social Login */
                .social-login {
                    position: relative;
                }

                .social-separator {
                    display: flex;
                    align-items: center;
                    text-align: center;
                }

                .social-separator::before,
                .social-separator::after {
                    content: "";
                    flex: 1;
                    border-bottom: 1px solid #e5e7eb;
                }

                .social-separator span {
                    padding: 0 0.5rem;
                    color: #6b7280;
                    background-color: #fff;
                }

                /* Social Buttons */
                .social-buttons {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 1rem;
                }

                .social-button {
                    padding: 0.75rem 1.5rem;
                    border-radius: 0.5rem;
                    border: 1px solid #e5e7eb;
                    background-color: #fff;
                    cursor: pointer;
                    transition: background-color 0.2s ease;
                    text-align: center;
                }

                .social-button:hover {
                    background-color: #f9fafb;
                }

                .social-button i {
                    margin-right: 0.5rem;
                }

                /* Signup Prompt */
                .signup-prompt {
                    text-align: center;
                    color: #6b7280;
                    font-size: 0.875rem;
                }

                .signup-link {
                    color: #ef4444;
                    cursor: pointer;
                    transition: color 0.2s ease;
                    font-weight: 500;
                }

                .signup-link:hover {
                    color: #dc2626;
                }
            `}</style>
        </div>
    );
};

export default UserLogin;